var $ = require('jquery');

function VereinsEditor() {
	var vnum = $("input[name='vnum_dtv']")
	var ltv = $("select[name='ltv_id']");
	var land = $("select[name='country_id']");

	function landChanged(deselectLtv) {
		if (land.val() != '') {
			if (land.find('option:selected').html() == 'Deutschland') {
				ltv.find('option').attr('disabled', false);
				ltv.find('option[value="EXT"]').attr('disabled', true);
				vnum.attr('disabled', false);
				if (deselectLtv) {
					ltv.val('');
				}
			}
			else {
				ltv.find('option').attr('disabled', true);
				ltv.find('option[value="EXT"]').attr('disabled', false);
				ltv.val('EXT');
				vnum.val('').attr('disabled', true);
			}
			ltv.trigger('chosen:updated');
		}
	}

	land.on('change', function () {
		landChanged(true);
	});
	landChanged(false);
}

module.exports = VereinsEditor;